import axios from 'axios';

/**
 * Instancia única de Axios para hablar con el backend.
 * La URL base se toma de la variable de entorno REACT_APP_API_URL (ver client/.env).
 */
const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

/**
 * Normaliza los errores: el backend responde { error: "mensaje" } o { mensaje }.
 * Dejamos siempre un Error con un .message legible para mostrar al usuario.
 */
http.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    const mensaje =
      data?.error ||
      data?.mensaje ||
      (error.code === 'ECONNABORTED'
        ? 'La solicitud tardó demasiado. Intentá de nuevo.'
        : error.message) ||
      'Ocurrió un error inesperado.';
    const normalizado = new Error(mensaje);
    normalizado.status = error.response?.status;
    normalizado.original = error;
    return Promise.reject(normalizado);
  }
);

export default http;
